import { render, staticRenderFns } from "./ernnTable.vue?vue&type=template&id=51b6752c&scoped=true"
import script from "./ernnTable.vue?vue&type=script&lang=ts"
export * from "./ernnTable.vue?vue&type=script&lang=ts"
import style0 from "./ernnTable.vue?vue&type=style&index=0&id=51b6752c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b6752c",
  null
  
)

export default component.exports